import MinimalCodeMirror from './react-codemirror';
import { EditorView, Decoration, WidgetType, keymap } from '@codemirror/view';
import { EditorState, StateField } from '@codemirror/state';
import { defaultKeymap, historyKeymap } from '@codemirror/commands';
window.UXPCodeMirror = {
    ReactCodeMirror: MinimalCodeMirror,
    EditorView,
    EditorState,
    StateField,
    Decoration,
    WidgetType,
    keymap,
    defaultKeymap,
    historyKeymap,
};
